<template>
  <main>
    <div class="content">

      <section class="box">
        <h3>
          <router-link :to="{ name: 'visa' }"><img src="@assets/img/logo.png" alt="" /></router-link>
        </h3>
        <div class="form">
          <el-input v-model="info.phone" ref="phone" maxlength="11" placeholder="请输入手机"></el-input>
          <el-input v-model="info.password" ref="password" type="password" placeholder="请输入密码"
            @keydown.enter.native="login" v-show="loginType === 0"></el-input>
          <el-input v-model="info.code" maxlength="4" ref="code" placeholder="请输入验证码" @keydown.enter.native="login"
            v-show="loginType === 1">
            <el-button slot="append" @click="getCode">{{
              codeTime === null ? "获取验证码" : codeTime + "s"
            }}</el-button>
          </el-input>
        </div>
        <div class="link">
          <!-- <a v-show="loginType === 0" @click="reset.show = true">忘记密码</a> -->
          <router-link :to="{ path: './register' }">免费注册</router-link>
        </div>
        <el-button class="go" type="warning" @click="login">登录</el-button>
        <div class="tab">
          <button :class="{ on: loginType === 0 }" @click="loginType = 0">
            账号密码登录
          </button>
          <button :class="{ on: loginType === 1 }" @click="loginType = 1">
            手机动态登录
          </button>
        </div>
      </section>
      <section class="reset" :class="{ show: reset.show }">
        <div class="reset_box">
          <h3>找回密码 <i class="icon-clear" @click="reset.show = false"></i></h3>
          <ul>
            <li>
              <span>手机号：</span>
              <el-input>
                <el-button slot="append">获取验证码</el-button>
              </el-input>
            </li>
            <li>
              <span>验证码：</span>
              <el-input></el-input>
            </li>
            <li><span>密码：</span><el-input type="password"></el-input></li>
            <li><span>确认密码：</span><el-input type="password"></el-input></li>
          </ul>
          <div class="btn">
            <el-button type="warning">下一步</el-button>
            <el-button type="success">完成</el-button>
          </div>
        </div>
      </section>

    </div>
  </main>
</template>

<script>
import $check from "@assets/js/check";
import $strategy from "@assets/js/strategy";
import $user from "@api/user";
export default {
  data() {
    return {
      fromPath: '',
      loginType: 0,
      reset: {
        show: false,
      },
      codeTime: null, // 验证码倒计时
      // 提交信息
      info: {
        phone: null,
        password: null,
        code: null,
      },
      to: null, // 登录成功后跳转的页面及携带的参数
    };
  },
  created() {
    const { params } = this.$route;
    !!params.name && (this.to = params);
  },
  methods: {
    login() {
      const { loginType, info } = this;
      const { phone, code, password } = info;
      if ($strategy.check(phone, "isMobile") === false) {
        this.$message.warning("手机号码格式有误！");
        this.$refs.phone.select();
        return;
      }
      if (loginType === 0) {
        if ($strategy.check(password, "isEmpty") || password.length < 6) {
          this.$message.warning("密码不能为空或长度小于6");
          this.$refs.password.select();
          return false;
        }
      } else {
        if ($strategy.check(code, "isEmpty") || code.length !== 4) {
          this.$message.warning("验证码有误！");
          this.$refs.code.select();
          return false;
        }
      }
      let data = { phoneNumber: phone };
      loginType === 0 ? (data.password = password) : (data.phoneCode = code);
      $user.login(data).then((res) => {
        const { error } = res;
        if (error) {
          return;
        }

        this.updateUserInfo(res);
        this.$message.success("登录成功!");
        this.setCookie("checked", "1", "");
        // 2024-10-09 修改成登录成功后 返回上一个进入的页面 提升用户体验
        setTimeout(() => {
          this.$router.back();
        }, 500);
        // const { to } = this;
        // this.$router.push(to || { name: "visa" });
      });
    },
    // 获取验证码
    getCode() {
      const { phone } = this.info;
      // 倒计时中
      if (this.codeTime !== null) {
        return;
      }
      // 有效性验证
      if ($check.isPhone(phone) === false) {
        this.$message.warning("手机号码有误！");
        return;
      }
      this.startCountdown("codeTime");
      $user.sendSMS(phone);
    },
  },
};
</script>

<style scoped src="./login.css"></style>